<div class="school-class-compare-block-categories">
  <div class="school-class-compare-block-categories__category"
       [ngClass]="{'active': currentCategory === category.value}"
       *ngFor="let category of data"
       (click)="selectCategory(category.value)">
    <span class="school-class-compare-block-categories__category-icon"><brt-icon [icon]="category.icon"></brt-icon></span>
    <span class="school-class-compare-block-categories__category-label">{{category.label}}</span>
  </div>
</div>
